<mat-form-field appearance="outline">
  <mat-label>{{ label | translate }}</mat-label>
  <input
    matInput
    [formControl]="timepickerControl"
    [matTimepicker]="picker"
    [required]="required"
  />
  <mat-timepicker-toggle matIconSuffix [for]="picker" />
  <mat-timepicker #picker />
</mat-form-field>
<div class="input-description">{{ description }}</div>
